var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Dependencies } from "~/core/decorator";
import { CaseOperatorPageService } from "~/services/domain-service/case-operator-page.service";
import { DataImportExcelInfoService } from "~/services/dataimp-service/data-import-excel-info.service.ts";
import { DataGrid, DataGridItem } from "@zct1989/vue-component";
import { MENU_CHANNEL } from "~/config/enum.config";
import { namespace } from "vuex-class";
var CollectionExecutionModule = namespace("collection-execution");
var CaseInfo = /** @class */ (function (_super) {
    __extends(CaseInfo, _super);
    function CaseInfo() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.caseInfo = {};
        return _this;
    }
    CaseInfo.prototype.activated = function () {
        this.refreshData();
    };
    CaseInfo.prototype.refreshData = function () {
        var _this = this;
        if (this.menuChannel === MENU_CHANNEL.Case_imported) {
            this.dataImportExcelInfoService
                .getImportCaseInfo(this.caseId)
                .subscribe(function (data) {
                _this.caseInfo = data;
            });
        }
        else {
            this.caseOperatorPageService
                .queryCaseInfo(this.caseId)
                .subscribe(function (data) {
                _this.caseInfo = data;
            });
        }
    };
    __decorate([
        Dependencies(CaseOperatorPageService)
    ], CaseInfo.prototype, "caseOperatorPageService", void 0);
    __decorate([
        Dependencies(DataImportExcelInfoService)
    ], CaseInfo.prototype, "dataImportExcelInfoService", void 0);
    __decorate([
        CollectionExecutionModule.State
    ], CaseInfo.prototype, "menuChannel", void 0);
    __decorate([
        CollectionExecutionModule.State
    ], CaseInfo.prototype, "caseId", void 0);
    CaseInfo = __decorate([
        Component({
            components: {
                DataGrid: DataGrid,
                DataGridItem: DataGridItem
            }
        })
    ], CaseInfo);
    return CaseInfo;
}(Vue));
export default CaseInfo;
